var render = function render(){var _vm=this,_c=_vm._self._c;return _c('machinery-form',{attrs:{"hasWritePerm":_vm.hasWritePerm,"visible":_vm.newMachineryDialog,"dialogTitle":'hfManagement.machineryPerformance.addMachinaryDialogTitle',"initFormValid":false,"machinery":_vm.newMachinery,"officeId":_vm.officeId},on:{"close":_vm.closeNewMachineryFormDialog,"savemachinery":_vm.createMachinery}})
}
var staticRenderFns = []

export { render, staticRenderFns }